<template>
  <div>
    <div class="course-info frc">
      <img class="mlefta" v-bind:src="courseInfo.cover | coverFilter" alt="">
      <div class="mrighta">
        <div class="frc">
          <span style="font-size: 20px">{{courseInfo.courseName}}</span>
        </div>
        <div class="frcs" style="margin-top: 20px;">
          <div>
            <span class="course-tag">{{courseInfo.teachClassification.classificationName}}</span>
          </div>
        </div>
        <!--
                <div class="frc">
                    <img src="@/assets/star.png" alt="" title="取消收藏" v-on:click="courseCollection" />
                    <img src="@/assets/star01.png" alt="" title="收藏本课程" v-on:click="courseCollection" />
                </div>
                -->
      </div>
    </div>
    <div class="c-introduce">
      <span style="color:#93999f; margin-right: 10px;">课程介绍</span>
      <span style="color: #333333;">{{courseInfo.introduce}}</span>
    </div>
    <div class="mcontent">
      <div class="mleft">
        <template v-for="(chapterItem, chapterIndex) in chapterList">
          <div v-bind:key="chapterIndex" class="chapter-item">
            <div class="chapter-title" v-on:click="chapterTap(chapterIndex)">
              <div style="font-size: 16px;font-weight: bold;">第{{chapterIndex + 1}}章 {{chapterItem.chapterName}}</div>
              <p class="chapter-desc">{{chapterItem.chapterIntroduce}}</p>
            </div>
            <el-collapse-transition>
              <ul class="excerpt-list" v-show="chapterItem.expand">
                <template v-for="(excerptItem, excerptIndex) in chapterItem.excerptList">
                  <li v-bind:key="excerptIndex" class="excerpt-item frc">
                    <div class="frc">
                      <span class="mcircular"></span>
                      <span class="noselector" style="margin: 0px 20px 0px 0px;"
                        v-on:click="classesStudy(chapterIndex, excerptIndex,excerptItem)">{{excerptIndex + 1}}
                        {{excerptItem.classesName}}</span>
                        <p :class="excerptItem.completeStatus == true ? 'bule' : 'red'">{{excerptItem.completeStatus == true ? '已完成' : '未完成'}}</p>
                    </div>
                  </li>
                </template>
              </ul>
            </el-collapse-transition>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "CourseChapter",
    components: {},
    data () {
      return {
        courseInfo: {
          teachArchitecture: {
            architectureName: ""
          },
          teachClassification: {
            classificationName: ""
          },
          teachDifficulty: {
            difficultyName: ""
          },
          sysUser: {
            nickName: ""
          }
        },
        chapterList: [],
        relevantCourseList: [], // 相关课程
        chapterIndex: -1,
        excerptIndex: -1
      };
    },
    computed: {
      userRole () {
        return this.$store.state.user.userInfo.roleKey;
      }
    },
    watch: {},
    filters: {
      coverFilter (cover) {
        return process.env.VUE_APP_imagePath + cover;
      }
    },
    mounted () {
      this.getCourseInfo(this.$route.query.courseId);
    },
    computed: {
      userInfo () {
        return this.$store.state.user.userInfo;
      }
    },
    methods: {
      getCourseInfo (courseId) {
        let that = this;
        that.HttpConnection.get(`/course/course/getCouCourse/${courseId}`).then(function (response) {
          that.courseInfo = response.data;
          console.log(that.courseInfo);
        });
        that.HttpConnection.get("/course/chapter/list/user/schedule", {
          params: {
            courseId: courseId
          }
        }).then(function (response) {
          if (response.rows.length > 0) {
            let _chapterList = [];
            for (let item of response.rows) {
              item.expand = false;
              _chapterList.push(item);
            }
            that.chapterList = _chapterList;
          } else {
            that.$message({
              message: "当前无章节",
              type: "error"
            });
          }
        });
        // that.HttpConnection.get("/course/course/list", {
        //   params: {
        //     architectureId: that.courseLevelIds.architectureId,
        //     classificationId: 0,
        //     difficultyId: 0,
        //     bottomClick: 1,
        //     permission: 1,
        //     pageNum: 1,
        //     pageSize: 4
        //   }
        // }).then(function (response) {
        //   console.log(that.courseLevelIds);
        //   that.relevantCourseList = response.rows;
        // });
      },
      classesStudy (chapterIndex, excerptIndex, row) {
        let that = this;
        this.chapterIndex = chapterIndex;
        this.excerptIndex = excerptIndex;
        let _classInfo = {
          teacherId: row.teacherId,
          teacherName: row.teacherName,
          classId: this.classId,
          classesId: row.classesId,
          classesName: row.classesName,
          classesType: row.classesType,
          videoName: row.classesName,
          videoUrl: row.classesVideo,
          materialsName: row.materialsName,
          materialsUrl: row.materialsUrl,
          scheduleId: row.scheduleId
        };
        sessionStorage.setItem("classInfo", JSON.stringify(_classInfo));
        let _classesId = that.chapterList[chapterIndex].excerptList[excerptIndex].classesId;
        var data = Date.now()
        var StartTime = Date.parse(that.userInfo.classerStartTime)
        var EndTime = Date.parse(that.userInfo.classerEndTime)
        if (data >= StartTime && data <= EndTime) {
          let _routeUrl = this.$router.push({
            path: "/RoomEnter",
            query: {
              classesId: _classesId
            }
          });
        } else {
          that.$message({
            message: "当前不在开班时间",
            type: "error"
          });
        }
        // localStorage.href(_routeUrl.href, "_blank");
      },
      chapterTap (chapterListIndex) {
        let that = this;
        let _chapterId = this.chapterList[chapterListIndex].chapterId;
        that.HttpConnection.get("/course/classes/list/user/schedule", {
          params: {
            chapterId: _chapterId
          }
        }).then(function (response) {
          if (response.rows.length > 0) {
            let _classList = [];
            for (let item of response.rows) {
              item.expand = false;
              item.excerptList = [];
              _classList.push(item);
            }
            that.chapterList[chapterListIndex].excerptList = _classList;
            that.chapterList[chapterListIndex].expand = !that.chapterList[chapterListIndex].expand;
            that.$forceUpdate();
          } else {
            that.$message({
              message: "当前无课时",
              type: "error"
            });
          }
        });
      },
      courseCollection () {
        let that = this;
        let courseId = that.courseInfo.courseId;
        that.HttpConnection.post(`/course/collection/${courseId}`).then(function (response) {
          that.courseInfo.collected = !that.courseInfo.collected;
        });
      }
    }
  };
</script>

<style scoped lang="scss">
  @import "../../styles/transition.scss";
  $bgc: #f5f7fa;
  $commonColor: #20a0ff;
  $borderRadius: 4px;

  .course-info {
    .mlefta {
      width: 218px;
      height: 120px;
    }

    .mrighta {
      flex-grow: 1;
      height: 120px;
      background-color: $bgc;
      border-radius: $borderRadius;
      padding: 20px;
      justify-content: space-between;
      border: 1px solid #ebedf0;
    }
  }

  .course-tag {
    background-color: #005cff;
    color: #ffffff;
    margin: 0px 16px 0px 0px;
    padding: 3px 6px;
    font-size: 12px;
  }

  .mcontent {
    display: flex;
    flex-direction: row;
  }

  .mleft {
    //width: 850px;
    flex-grow: 1;
  }

  .chapter-item {
    margin: 0px 0px 20px 0px;
    border: 1px solid #ebedf0;
    border-radius: 4px;
  }

  .chapter-title {
    cursor: pointer;
    background-color: $bgc;
    padding: 20px 24px 20px 24px;
  }

  .chapter-desc {
    font-size: 12px;
    color: #808080;
    margin: 10px 0px 0px 0px;
  }

  .excerpt-list {
    padding: 10px 0px 10px 0px;

    .excerpt-item {
      height: 40px;
      justify-content: space-between;
      padding: 0px 60px 0px 34px;
      font-size: 14px;

      .mcircular {
        width: 4px;
        height: 4px;
        display: inline-block;
        background-color: #d0e3ff;
        margin: 0px 8px 0px 0px;
        border-radius: 2px;
      }

      .m-icon-play {
        cursor: pointer;
      }
    }

    .excerpt-item:hover {
      background-color: $bgc;

      .mcircular {
        background-color: #005cff;
      }
    }
  }

  .mright {
    width: 300px;
    border-radius: $borderRadius;

    .mr-item {
      background-color: $bgc;
      border: 1px solid #ebedf0;
      border-radius: $borderRadius;
      margin: 0px 0px 10px 0px;
      padding: 20px;

      ul {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        margin: 20px 0px 0px 0px;

        li {
          width: 124px;
          cursor: pointer;
          margin: 2px 2.5px;

          img {
            width: 124px;
            height: 68px;
          }

          p {
            font-size: 12px;
            margin: 8px 0px 0px 0px;
            text-align: center;
          }
        }
      }
    }
  }

  .icon-tag {
    width: 20px;
    height: 20px;
    margin: 0px 6px;
  }

  .start-learn {
    width: 80px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    color: #ffffff;
    background-color: #00c08c;
    border-radius: 4px;
  }

  .start-learn-b {
    width: 80px;
    height: 28px;
    text-align: center;
    line-height: 28px;
    color: #ffffff;
    background-color: #ebedf0;
    border-radius: 4px;
  }

  .c-introduce {
    border: 1px solid #ebedf0;
    background-color: #f5f7fa;
    font-size: 12px;
    padding: 20px 30px 20px 24px;
    margin: 20px 0px 20px 0px;
  }

  .related-course {
    width: 4px;
    height: 12px;
    display: inline-block;
    background-color: #20a0ff;
    margin-right: 10px;
    border-radius: 2px;
  }
  .bule{
    border:1px solid #67C23A;
    border-radius: 4px;
    color: #67C23A;
    font-size:12px;
    padding: 2px 5px;
  }
  .red{
    border: 1px solid #F56C6C;
      border-radius: 4px;
    color: #F56C6C;
    font-size:12px;
    padding: 2px 5px;
  }
</style>